import { useEffect } from "react";
import { useParams, Link } from "react-router";
import DynamicTable from "../../components/tables/DynamicTable";
import Button from "../../components/ui/button/Button";
import Spinner from "../../components/ui/spinner";
import useMenus from '../../hooks/Menu/useMenus'

import type { DataProps } from '../../components/tables/DynamicTable'

const columns = [
  "id",
  "name",
  "qrCode",
  "languages",
  "menuSections",
  "menuItems",
  "editAction",
  "description"
]

const MenuList = () => {
  const { id } = useParams();
  const { menus, loading, error, refetchMenus } = useMenus(id, {
    fetchPolicy: "network-only",
    refetchOnMount: false,
  });
    
  useEffect(() => {
    refetchMenus();
  }, [refetchMenus]);

  if (loading) return <Spinner />;
  if (error) return <p>Error: {error.message}</p>;
  
  return (
    <>
      <DynamicTable data={menus as DataProps[]} columns={columns} rowKey="menus" initialPageSize={100} />
      <Link to={`/restaurants/${id}/menus/new`}>
        <Button 
          size="md" 
          variant="primary"
          className="my-6"
        >
          New
        </Button>
      </Link>
    </>
  )
}

export default MenuList;
